import Navbar from "../../../components/Navbar/Navbar";
import EditLabRequest from "../components/EditLabRequest/EditLabRequest";

export default function EditLabRequestPage() {
    return (
        <>
            <Navbar title="Edit Lab Request" />
            <div className="page">
                <EditLabRequest />
            </div>
        </>
    );
}
